import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions } from "../../../reducers/cadastro/alertas.actions";
import { getAlertas } from "../../../selectors/cadastro/alertas.selectors";
import AlertaPage from "./AlertaPage";
import {
  actions as routeActions,
  types as routes,
} from "../../../reducers/rotas.actions";
import { getPayload } from "../../../selectors/routes.selectors";

const AlertaPageConnected = () => {
  const { loading, data, filter, nomeCliente } = useSelector(getAlertas);
  const cliente = useSelector(getPayload);

  const dispatch = useDispatch();

  const handlePagination = (e, page) => {
    dispatch(
      actions.obterAlertas.request({
        pagina: page,
        nome: filter,
        idCliente: cliente.id,
      })
    );
  };

  const handleDelete = (e, id) => {
    dispatch(actions.deletarAlerta.request({ id }));
  };

  const handleActivate = (e, id) => {
    dispatch(actions.reativarAlerta.request({ id, situacao: "A" }));
  };

  const handleEdit = (e, id) => {
    dispatch(
      routeActions.redirectTo(routes.EDITAR_ALERTA, {
        id: id,
      })
    );
  };

  const handleAdd = () => {
    dispatch(routeActions.redirectTo(routes.CRIAR_ALERTA, { idCliente: cliente.id }));
  };

  const handleGoBack = () => {
    dispatch(routeActions.redirectTo(routes.CADASTRO_CLIENTE));
  };

  return (
    <AlertaPage
      data={data}
      loading={loading}
      handlePagination={handlePagination}
      handleAdd={handleAdd}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
      handleGoBack={handleGoBack}
      handleActivate={handleActivate}
      filtroAtual={filter}
      nomeCliente={nomeCliente}
      cliente={cliente}
    />
  );
};

export default AlertaPageConnected;
